<svg
  width="12"
  height="12"
  viewBox="0 0 12 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M7.70258 3.65665L6.00012 0.0888672L4.29767 3.65665L0.378418 4.17328L3.24549 6.89492L2.52572 10.782L6.00012 8.89628L9.47453 10.782L8.75476 6.89492L11.6218 4.17328L7.70258 3.65665Z"
    fill="currentColor"
  />
</svg>
